module.exports = __webpack_public_path__ + "static/media/sidebar-3.6e881969.jpg";